import theme from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const sentryFallbackStyle = {
  sentryFallback: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100dvh',
    minWidth: '100dvw',
    background: 'linear-gradient(180deg, #e6f7ff, #dff3ff)',
    p: 3,
    gap: 3,
    '& .logo': {
      width: getResponsiveSize(280),
      mt: getResponsiveSize(-48),
    },
    '& .sf-card': {
      width: 'min(960px, 92vw);',
      background: theme.palette.myPrimary.white,
      border: '1px solid rgba(3, 37, 59, 0.06)',
      borderRadius: getResponsiveSize(16),
      boxShadow: '0 16px 40px rgba(3, 28, 45, 0.10)',
      padding: '40px 44px 28px',
      textAlign: 'center',
      '& .error-icon': {
        m: '0 auto',
        mb: 2,
      },
      '& .sf-title': {
        my: 1,
        color: '#1c3f5f',
        fontSize: getResponsiveSize(48),
        letterSpacing: '0.2px',
        lineHeight: '1.15',
        ...theme.palette.propVars.regularFontWeight,
      },
      '& .sf-subtitle': {
        m: '0 auto',
        mb: 2,
        maxWidth: '720px',
        lineHeight: '1.6',
        color: '#314e64',
        ...theme.palette.propVars.regularFontWeight,
      },
      '& .sf-ref': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'baseline',
        color: '#314e64',
        gap: 1.25,
        my: 1.5,
        '& code': {
          background: '#f3f8fb',
          py: 0.25,
          px: 0.75,
          borderRadius: 0.75,
          fontSize: '0.95em',
        },
        '& .sf-link ': {
          color: theme.palette.myPrimary.lightBlue70,
          borderRadius: getResponsiveSize(10),
          width: getResponsiveSize(40),
          height: getResponsiveSize(40),
        },
      },
      '& .sf-actions': {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: 1.5,
        mt: 1.5,
        mb: 1,
      },
    },
    '& .sf-snackbar': {
      background: theme.palette.myPrimary.white,
      color: '#1c3f5f',
      border: '1px solid rgba(3, 37, 59, 0.06)',
      boxShadow: '0 16px 40px rgba(3, 28, 45, 0.10)',
      borderRadius: getResponsiveSize(12),
      padding: `${getResponsiveSize(10)}px ${getResponsiveSize(16)}px`,
      minWidth: 'auto',
      maxWidth: '92vw',
      letterSpacing: '0.2px',
      ...theme.palette.propVars?.semiBoldFontWeight,
    },
  },
};
